import { usePersonasList, useEffectiveAccess } from '@/api/queries'

export function Dashboard() {
  const list = usePersonasList()
  const access = useEffectiveAccess()
  const total = list.data?.items.length ?? 0
  const drafts = (list.data?.items ?? []).filter((p) => p.status === 'Draft').length

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>Dashboard</h1>
          <p>Signed in as <span className="mono">{access.data?.upn ?? '…'}</span> ·
            role <b>{access.data?.effectiveRole ?? '…'}</b></p>
        </div>
      </div>
      <div className="stack-16" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 'var(--sp-16)' }}>
        <Stat icon="📋" label="Personas" value={total.toString()} />
        <Stat icon="✏️" label="Drafts" value={drafts.toString()} />
        <Stat icon="🔓" label="Capabilities" value={(access.data?.capabilities.length ?? 0).toString()} />
      </div>
    </div>
  )
}

function Stat({ icon, label, value }: { icon: string; label: string; value: string }) {
  return (
    <div className="card pad">
      <div className="muted" style={{ fontSize: 'var(--fs-200)' }}>{icon} {label}</div>
      <div style={{ fontSize: 'var(--fs-700)', fontWeight: 600, marginTop: 4 }}>{value}</div>
    </div>
  )
}
